import { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const CVCfive = (props: Props) => {
  const { disabled, register } = props;

  const info = [
    '插管部位持續出血時。',
    '插管部位變紅或有膿液滲出時。',
    '插管部位有發熱或疼痛感時。',
    '插管處、肩膀或手臂出現麻木或疼痛時。',
    '插管側的臉部、肩膀或手臂腫脹時。',
    '導管卡住或脫落時。',
    '縫線脫落時。',
    '導管損壞（破損或出現破洞）時。',
    '體溫超過攝氏 38 度時。',
  ];

  return (
    <Fragment>
      <SectionTitle title="5. 應向醫務人員報告的情況" />
      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          {info.map(a => {
            return (
              <Grid item xs={11.5}>
                <Typography sx={{ fontSize: '14px', lineHeight: '30px' }}>
                  • {a}
                </Typography>
              </Grid>
            );
          })}
          <Typography
            sx={{
              fontSize: '14px',
              lineHeight: '30px',
              fontWeight: 500,
              marginTop: '40px',
            }}
          >
            我已充分理解說明並同意插入中心靜脈導管。
          </Typography>
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCfive;
